import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter as Router, Switch } from 'react-router-dom';
import store from "./store/redux-store";
import GLOBAL_CONFIG from '../src/config/config';
import 'promise-polyfill/src/polyfill';

import { initiateNativeBridge } from './services/native-bridge';
import { StyleSelector } from './components/common/style-selector/style-selector';
import { SentryService } from './services/sentry-service';

initiateNativeBridge();
SentryService.init()

ReactDOM.render(
    <Provider store={store}>
        <Router basename={GLOBAL_CONFIG.routerBasename}>
            <Switch>
                <StyleSelector />
            </Switch>
        </Router>
    </Provider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
